import { render, staticRenderFns } from "./terveyskeskuskoulutusjakson-hyvaksynta.vue?vue&type=template&id=41ceceae&scoped=true&"
import script from "./terveyskeskuskoulutusjakson-hyvaksynta.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjakson-hyvaksynta.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjakson-hyvaksynta.vue?vue&type=style&index=0&id=41ceceae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ceceae",
  null
  
)

export default component.exports